module.exports = __webpack_public_path__ + "static/media/gayatri_potbhare.49805948.png";